import { create } from "zustand";

type DirtySourceMap = Record<string, boolean>;

interface UnsavedChangesState {
  dirtySources: DirtySourceMap;
  setDirtySource: (sourceId: string, isDirty: boolean) => void;
  clearDirtySource: (sourceId: string) => void;
  hasDirtySources: () => boolean;
}

export const useUnsavedChangesStore = create<UnsavedChangesState>((set, get) => ({
  dirtySources: {},
  setDirtySource: (sourceId: string, isDirty: boolean) => {
    set((state) => ({
      dirtySources: {
        ...state.dirtySources,
        [sourceId]: isDirty,
      },
    }));
  },
  clearDirtySource: (sourceId: string) => {
    set((state) => {
      const next = { ...state.dirtySources };
      delete next[sourceId];
      return { dirtySources: next };
    });
  },
  hasDirtySources: () => {
    const sources = get().dirtySources;
    return Object.values(sources).some(Boolean);
  },
}));

export function hasRegisteredUnsavedChanges(): boolean {
  return useUnsavedChangesStore.getState().hasDirtySources();
}
